import { captureException } from '@sentry/react';
import { enqueueSnackbar } from '~/utils/notifications';
import { redactDicomUids } from '~/utils/phiRedaction';

/** Extract a user-friendly error message from an unknown error */
export const getErrorMessage = (error: unknown): string => {
    if (error instanceof Error) {
        return error.message;
    }
    if (typeof error === 'string') {
        return error;
    }
    return 'Unknown error';
};

/** The error's name only, for a log line: its message can name a structure. */
export const errorName = (caught: unknown): string =>
    caught instanceof Error ? caught.name : 'unknown error';

/**
 * Logs an error with every DICOM UID redacted, reports it to Sentry (which
 * redacts on its own), and optionally tells the user.
 */
export const handleError = (
    error: unknown,
    errorMessage?: string,
    key?: string
) => {
    console.error(redactDicomUids(error));
    captureException(error);
    if (errorMessage) {
        enqueueSnackbar(errorMessage, {
            variant: 'error',
            key,
        });
    }
};
